export default __webpack_public_path__ + "static/media/punte alberete 4 P.c0163178.mp3";